module.exports = __webpack_public_path__ + "static/media/personalphoto.e28b8914.jpg";